export const calculateDistance = (point1, point2) => {
  const R = 6371; // Earth radius in kilometers
  const dLat = toRad(point2.latitude - point1.latitude);
  const dLon = toRad(point2.longitude - point1.longitude);
  const a = 
    Math.sin(dLat/2) * Math.sin(dLat/2) +
    Math.cos(toRad(point1.latitude)) * Math.cos(toRad(point2.latitude)) * 
    Math.sin(dLon/2) * Math.sin(dLon/2); 
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a)); 
  return R * c;
};

export const toRad = (value) => {
  return value * Math.PI / 180;
};

export const calculatePathDetails = (path, locations) => {
  let totalDistance = 0;
  const segments = [];
  
  for (let i = 0; i < path.length - 1; i++) {
    const loc1 = locations.find(loc => loc.id === path[i]);
    const loc2 = locations.find(loc => loc.id === path[i + 1]);
    
    if (loc1 && loc2) {
      const distance = calculateDistance(loc1, loc2);
      totalDistance += distance;
      
      segments.push({
        from: loc1,
        to: loc2,
        distance: distance,
        fromIndex: i,
        toIndex: i + 1
      });
    }
  }
  
  return { distance: totalDistance, segments: segments };
};

export const calculatePathDuration = (path, locations, connections) => {
  if (!path || path.length < 2 || !connections || connections.length === 0) {
    return 0;
  }
  
  let totalDuration = 0;
  
  for (let i = 0; i < path.length - 1; i++) {
    const point1Id = path[i];
    const point2Id = path[i + 1];
    
    // Find the connection between these two points
    const connection = connections.find(conn => {
      if (!conn.points || conn.points.length !== 2) return false;
      
      const [connPoint1, connPoint2] = conn.points;
      
      // Check both directions of the connection
      return (
        (connPoint1.id === point1Id && connPoint2.id === point2Id) ||
        (connPoint2.id === point1Id && connPoint1.id === point2Id)
      );
    });
    
    if (connection && connection.duration) {
      totalDuration += parseFloat(connection.duration);
    }
  }
  
  return totalDuration;
}; 